export enum WidgetDataHooks {
  MAIN_CONTAINER = 'widget-main-container',
}
